const TransactionCategory = () =>
  import(
    /* webpackChunkName: "TransactionCategory" */ '@/view/pages/transaction-category/TransactionCategory.vue'
  );
const ListTransactionCategoryPage = () =>
  import(
    /* webpackChunkName: "ListTransactionCategoryPage" */ '@/view/pages/transaction-category/List.vue'
  );


export default [
  {
    path: '/transaction-categories',
    component: TransactionCategory,
    children: [
      {
        path: '/',
        name: 'list-transaction-categories',
        component: ListTransactionCategoryPage,
        meta: {
          title: 'Danh sách danh mục thu chi - ClickBuy',
        },
      },
    ],
  },
];
